const getPoint = (points, i) => {
  i = (i + points.length) % points.length

  return points[i]
}

export default getPoint
